import * as yup from "yup";
export var SensorConfigurationSchema;
(function (SensorConfigurationSchema) {
    SensorConfigurationSchema.Schema = yup.object().shape({
        id: yup.string().required(),
        name: yup.string().required(),
        streamName: yup
            .string()
            .required()
            .matches(/^[a-zA-Z\d]+$/),
    });
})(SensorConfigurationSchema || (SensorConfigurationSchema = {}));
//# sourceMappingURL=SensorConfigurationSchema.js.map